import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header from '../../../shared/Header/Header';
import imprivataIcon from '../Icons/imprivata.svg';
import hexLoaderIcon from '../Icons/hex-loader.svg';
import lock from '../Icons/lock.svg';
import './WaitingForIdvResult.scss';

/**
 * WaitingForIdvResult prompt
 * @class WaitingForIdvResult
 * @extends {Component}
 */
class WaitingForIdvResult extends Component {

  static propTypes = {
    /** Header title */
    headerTitle: PropTypes.string,
    /** The component to be used for logout */
    logoutComponent: PropTypes.object,
    /** The DOM tree/component to be used for the footer */
    footer: PropTypes.object,
    /** Use Parkland custom UX */
    useCustomUX: PropTypes.bool,
  };
  static defaultProps = {
    headerTitle: 'Verify identity',
    logoutComponent: null,
    // Parkland custom UX
    useCustomUX: false,
  };

  render() {
    return (
      <div className='CIDRA'>
        {this.props.useCustomUX ?
          (<Header />)
          :
          (
            <div className='Header-Box'>
              <img src={lock} className='Modality-Icon' alt='lock' />
              <div className='Header-Text'>
                <span>{this.props.headerTitle}</span>
              </div>
            </div>
          )
        }
        <div className='login-container'>
          <div className='wait-content'>
            <div className='message-container'>
              <div className='message-title'>Verifying your identity.</div>
              <div className='message-details'>This may take a moment.</div>
            </div>
            <div className='hex-loader'>
              <img src={hexLoaderIcon} alt='hex loader' />
            </div>
          </div>
        </div>
        <hr className='Footer-hr' />
        <img className='Footer' src={imprivataIcon} alt='logo' />
      </div>
    );
  }
}

export default WaitingForIdvResult;
